import { useTasks } from "../api/tasks";
import type { TaskContext } from "../api/types";
import { CATEGORY_META, categoryColor } from "../lib/grade";

// Colored pill for the operator-selected task category — the "type" of task the video belongs
// to. The recording's metadata snapshot froze the category at record time, so recordings made
// before the macro-category catalog say "Featured"/"Other"; prefer the task's CURRENT category
// from the live catalog (matched by id) and fall back to the snapshot when the task is gone.
// Renders nothing when the recording has no task context (older recordings).
export default function CategoryBadge({
  task,
  className,
}: {
  task: TaskContext | null | undefined;
  className?: string;
}) {
  const { data: catalog } = useTasks();
  if (!task || (!task.category && !task.category_id)) return null;
  const live = task.id ? catalog?.find((t) => t.id === task.id) : undefined;
  const categoryId = live?.categoryId ?? task.category_id;
  // the admin-picked hue from the App Tasks page wins; the static map covers old/unknown ids
  const color = live?.categoryColor ?? categoryColor(categoryId);
  const label =
    live?.categoryEn ?? task.category ?? CATEGORY_META[categoryId ?? ""]?.label ?? categoryId;
  return (
    <span
      className={`cat-badge${className ? ` ${className}` : ""}`}
      style={{ ["--sc" as string]: color }}
      title={task.title ? `Task: ${task.title}` : "Operator-selected task category"}
    >
      {label}
    </span>
  );
}
